<template>
    <b-card no-body class="rounded">
        <b-card-text class="p-2" :style="'background-color:' + color">
            <div>
                <div class="d-flex justify-content-between">
                    <h6>{{ mensaje.user.name + ' ' + mensaje.user.surnames }}</h6>
                    <h6 class="pl-5">{{ mensaje.user.email }}</h6>
                </div>
            </div>
        </b-card-text>
        <b-card-text>
            <div class="p-2">
                <span v-html="mensaje.mensaje"></span>
            </div>

        </b-card-text>
        <b-card-text class="p-2" :style="'background-color:' + color">
            {{ mensaje.created_at }}
        </b-card-text>
    </b-card>
</template>


<script>
    export default {
        props: ['mensaje' , 'color']
    }
</script>